const HotelExtrasTableColumns = [
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "default_sell_price", labelAr: "سعر البيع", labelEn: "Sell Price", sortable: true },
    { id: "default_cost_price", labelAr: "سعر التكلفة", labelEn: "Cost Price", sortable: true },
    { id: "default_pricing_basis", labelAr: "أساس التسعير", labelEn: "Pricing Basis", sortable: false },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default HotelExtrasTableColumns;
